import React, { useEffect, useState } from 'react';
import { BANNERS_URL, getFetchRequest, postFetchRequest, putFetchRequest, deleteFetchRequest } from '../store/requests';
import { makeUrl, errorCallback } from '../constant';

const BannerTab = ({ isCollapsed }) => {
    const [banners, setBanners] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [editingBanner, setEditingBanner] = useState(null);
    const [formData, setFormData] = useState({
        title: '',
        text: '',
        content: '',
        background_color: '',
        text_color: '',
        subtext_color: '',
        logo_image_url: '',
        product_image_url: '',
        order_index: 0,
        is_active: true
    });

    const successGetBannersCallback = (result) => {
        setBanners(result);
    };

    useEffect(() => {
        getFetchRequest(makeUrl([BANNERS_URL]), successGetBannersCallback, errorCallback);
    }, []);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleEdit = (banner) => {
        setEditingBanner(banner);
        setFormData({
            title: banner.title,
            text: banner.text || '',
            content: banner.content || '',
            background_color: banner.background_color || '',
            text_color: banner.text_color || '',
            subtext_color: banner.subtext_color || '',
            logo_image_url: banner.logo_image_url || '',
            product_image_url: banner.product_image_url || '',
            order_index: banner.order_index,
            is_active: banner.is_active
        });
        setIsEditing(true);
    };

    const handleNew = () => {
        setEditingBanner(null);
        setFormData({
            title: '',
            text: '',
            content: '',
            background_color: '',
            text_color: '',
            subtext_color: '',
            logo_image_url: '',
            product_image_url: '',
            order_index: banners.length,
            is_active: true
        });
        setIsEditing(true);
    };

    const handleCancel = () => {
        setIsEditing(false);
        setEditingBanner(null);
        setFormData({
            title: '',
            text: '',
            content: '',
            background_color: '',
            text_color: '',
            subtext_color: '',
            logo_image_url: '',
            product_image_url: '',
            order_index: 0,
            is_active: true
        });
    };

    const handleSave = () => {
        const successCallback = () => {
            getFetchRequest(makeUrl([BANNERS_URL]), successGetBannersCallback, errorCallback);
            handleCancel();
        };

        if (editingBanner) {
            // Обновление существующего баннера
            putFetchRequest(
                makeUrl([BANNERS_URL, editingBanner.id, '/']),
                formData,
                successCallback,
                errorCallback
            );
        } else {
            // Создание нового баннера
            postFetchRequest(
                makeUrl([BANNERS_URL]),
                formData,
                successCallback,
                errorCallback
            );
        }
    };

    const handleDelete = (bannerId) => {
        if (window.confirm('Вы уверены, что хотите удалить этот баннер?')) {
            const successCallback = () => {
                getFetchRequest(makeUrl([BANNERS_URL]), successGetBannersCallback, errorCallback);
            };

            deleteFetchRequest(
                makeUrl([BANNERS_URL, bannerId, '/']),
                successCallback,
                errorCallback
            );
        }
    };

    const sortedBanners = banners.sort((a, b) => a.order_index - b.order_index);

    if (isEditing) {
        return (
            <section className={`workspace ${isCollapsed === null ? '' : isCollapsed ? 'workspace_collapsed' : 'workspace_full-width'} config__page`}>
                <h1 className="config__title">
                    {editingBanner ? 'Редактировать баннер' : 'Создать новый баннер'}
                </h1>
                
                <div className="banner__form">
                    <div className="banner__form-group">
                        <label className="banner__label">Заголовок:</label>
                        <input
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleInputChange}
                            className="config__input"
                            placeholder="Введите заголовок"
                            required
                        />
                    </div>

                    <div className="banner__form-group">
                        <label className="banner__label">Текст:</label>
                        <textarea
                            name="text"
                            value={formData.text}
                            onChange={handleInputChange}
                            className="config__input banner__textarea"
                            placeholder="Введите текст. Можно использовать <br> для переноса строки"
                            rows="3"
                        />
                    </div>

                    <div className="banner__form-group">
                        <label className="banner__label">Подтекст:</label>
                        <textarea
                            name="content"
                            value={formData.content}
                            onChange={handleInputChange}
                            className="config__input banner__textarea"
                            placeholder="Введите подтекст. Можно использовать <br> для переноса строки"
                            rows="3"
                        />
                    </div>

                    <div className="banner__form-group">
                        <label className="banner__label">Цвет фона (HEX):</label>
                        <input
                            type="text"
                            name="background_color"
                            value={formData.background_color}
                            onChange={handleInputChange}
                            className="config__input"
                            placeholder="#FFFFFF"
                            pattern="^#[0-9A-Fa-f]{6}$"
                        />
                    </div>

                    <div className="banner__form-group">
                        <label className="banner__label">Цвет текста (HEX):</label>
                        <input
                            type="text"
                            name="text_color"
                            value={formData.text_color}
                            onChange={handleInputChange}
                            className="config__input"
                            placeholder="#FFFFFF"
                            pattern="^#[0-9A-Fa-f]{6}$"
                        />
                    </div>

                    <div className="banner__form-group">
                        <label className="banner__label">Цвет подтекста (HEX):</label>
                        <input
                            type="text"
                            name="subtext_color"
                            value={formData.subtext_color}
                            onChange={handleInputChange}
                            className="config__input"
                            placeholder="#FFFFFF"
                            pattern="^#[0-9A-Fa-f]{6}$"
                        />
                    </div>

                    <div className="banner__form-group">
                        <label className="banner__label">URL логотипа компании:</label>
                        <input
                            type="url"
                            name="logo_image_url"
                            value={formData.logo_image_url}
                            onChange={handleInputChange}
                            className="config__input"
                            placeholder="https://example.com/logo.jpg"
                        />
                    </div>

                    <div className="banner__form-group">
                        <label className="banner__label">URL изображения товара:</label>
                        <input
                            type="url"
                            name="product_image_url"
                            value={formData.product_image_url}
                            onChange={handleInputChange}
                            className="config__input"
                            placeholder="https://example.com/product.jpg"
                        />
                    </div>

                    <div className="banner__form-group">
                        <label className="banner__label">Порядок отображения:</label>
                        <input
                            type="number"
                            name="order_index"
                            value={formData.order_index}
                            onChange={handleInputChange}
                            className="config__input"
                            min="0"
                        />
                    </div>

                    <div className="banner__form-group">
                        <label className="config__label banner__checkbox-label">
                            <input
                                type="checkbox"
                                name="is_active"
                                checked={formData.is_active}
                                onChange={handleInputChange}
                                className="config__checkbox"
                            />
                            Активен
                        </label>
                    </div>

                    <div className="banner__form-actions">
                        <button onClick={handleSave} className="banner__btn banner__btn_save">
                            Сохранить
                        </button>
                        <button onClick={handleCancel} className="banner__btn banner__btn_cancel">
                            Отмена
                        </button>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className={`workspace ${isCollapsed === null ? '' : isCollapsed ? 'workspace_collapsed' : 'workspace_full-width'} config__page`}>
            <div className="banner__header">
                <h1 className="config__title">Управление баннерами</h1>
                <button onClick={handleNew} className="banner__btn banner__btn_new">
                    Создать новый баннер
                </button>
            </div>

            <div className="banner__list">
                {sortedBanners.length === 0 ? (
                    <p className="banner__empty">Баннеры не найдены</p>
                ) : (
                    sortedBanners.map(banner => (
                        <div key={banner.id} className={`banner__item ${!banner.is_active ? 'banner__item_inactive' : ''}`}>
                            <div className="banner__item-content">
                                <h3 className="banner__item-title">{banner.title}</h3>
                                {banner.text && <p className="banner__item-text">{banner.text}</p>}
                                {banner.content && <p className="banner__item-content">{banner.content}</p>}
                                {banner.background_color && (
                                    <div className="banner__item-color">
                                        <span>Цвет фона: </span>
                                        <div 
                                            style={{
                                                backgroundColor: banner.background_color,
                                                width: '30px',
                                                height: '20px',
                                                display: 'inline-block',
                                                border: '1px solid #ccc',
                                                borderRadius: '3px'
                                            }}
                                        ></div>
                                        <span> {banner.background_color}</span>
                                    </div>
                                )}
                                {banner.logo_image_url && (
                                    <div className="banner__item-image">
                                        <p>Логотип: <img src={banner.logo_image_url} alt="Logo" style={{maxWidth: '100px', maxHeight: '50px'}} /></p>
                                    </div>
                                )}
                                {banner.product_image_url && (
                                    <div className="banner__item-image">
                                        <p>Товар: <img src={banner.product_image_url} alt="Product" style={{maxWidth: '100px', maxHeight: '50px'}} /></p>
                                    </div>
                                )}
                                <div className="banner__item-meta">
                                    <span>Порядок: {banner.order_index}</span>
                                    <span>Статус: {banner.is_active ? 'Активен' : 'Неактивен'}</span>
                                </div>
                            </div>
                            <div className="banner__item-actions">
                                <button 
                                    onClick={() => handleEdit(banner)} 
                                    className="banner__btn banner__btn_edit"
                                >
                                    Редактировать
                                </button>
                                <button 
                                    onClick={() => handleDelete(banner.id)} 
                                    className="banner__btn banner__btn_delete"
                                >
                                    Удалить
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </section>
    );
};

export default BannerTab;